import GeneralError from '../../pages/GeneralError';
import { ServerError } from './ServerError';
import { AxiosError, HttpStatusCode } from 'axios';
import NoAccessView from './NoAccessView';
import AboutJaaSection from '../Promotional/AboutJaaSection';
import { Stack } from '@mui/material';
import { ContentNotFound } from './ContentNotFound';

interface ErrorViewProps {
  apiError: AxiosError | null;
}

export default function ErrorView({ apiError }: Readonly<ErrorViewProps>) {
  if (apiError === null) {
    return <GeneralError />;
  }

  if (apiError.response?.status === HttpStatusCode.NotFound) {
    return <ContentNotFound />;
  }

  if (
    apiError.response?.status === HttpStatusCode.Unauthorized ||
    apiError.response?.status === HttpStatusCode.Forbidden
  ) {
    return (
      <Stack direction='column' useFlexGap spacing={6}>
        <NoAccessView />
        <AboutJaaSection />
      </Stack>
    );
  }

  if (
    apiError.response &&
    apiError.response.status >= HttpStatusCode.InternalServerError
  ) {
    return <ServerError />;
  }

  return <GeneralError />;
}
